import { CREHANA_LEGAL_PAGE_KEY } from '@/views/CrehanaLegal/constants';

const en = {
  [CREHANA_LEGAL_PAGE_KEY]: {
    MENU_TITLE: 'Content',
    UPDATED_AT: 'Last updated date:',
    GO_BACK: 'Go back',
    TERMS_AND_CONDITIONS_TITLE: 'Terms and conditions',
    TERMS_AND_CONDITIONS_B2B_TITLE: 'Terms and conditions B2B',
    TERMS_AND_CONDITIONS_B2B_EN_TITLE: 'Terms and conditions B2B',
    TERMS_AND_CONDITIONS_B2B_BR_TITLE: 'Terms and conditions B2B (Brazil)',
    PRIVACY_TITLE: 'Privacy and personal data protection policies',
    PRIVACY_BR_TITLE: 'Privacy policy (Brazil)',
    AUTHORIZATION_FOR_PROCESSING_PERSONAL_DATA_ATS_TITLE:
      'Authorization for Processing Personal Data ATS',
    PERSONAL_DATA_PROTECTION_POLICY_CREHANA_ATS_TITLE:
      'Personal Data Protection Policy CREHANA ATS',
    PRIVACY_PE_LABEL: 'Peru',
    PRIVACY_CO_LABEL: 'Colombia',
    PRIVACY_CL_LABEL: 'Chile',
    PRIVACY_MX_LABEL: 'Mexico',
    PRIVACY_NOTICE_MX_TITLE: 'Privacy notices (Mexico)',
    PRIVACY_NOTICE_CO_TITLE: 'Privacy notices (Colombia)',
    MEMBERSHIP_POLICY_TITLE: 'Membership Policies',
    MEMBERSHIP_POLICY_PREMIUM_LABEL: 'Individual Premium',
    MEMBERSHIP_POLICY_DUO_LABEL: 'Premium Duo',
    MEMBERSHIP_POLICY_FAMILY_LABEL: 'Family Premium',
    MEMBERSHIP_POLICY_STUDENT_LABEL: 'Student',
    PAYG_POLICY_TITLE: 'Pay As You Go Policies',
    TEACHER_AGREEMENT_TITLE: 'Teacher Agreement',
    COOKIES_POLICY_TITLE: 'Cookies Policy',
    ARCO_REQUEST_TITLE: 'ARCO Request',
    REFUND_POLICY_TITLE: 'Refund Policies',
    SECURITY_AND_PRIVACY_POLICY_TITLE:
      'General information security and privacy policy',
    SLA_TITLE: 'Service Level Agreement (SLA)',
  },
};

export default en;
